import { useDemoLookupAllowance } from '@hooks';
import { Alert } from 'antd';
import React from 'react';

/**
 * Shows a trial tenant how many vehicle lookups it has left.
 *
 * Sits at the top of the screen that spends them rather than beside the search box, so it
 * reads as a property of the account rather than a note on one field. Renders nothing for
 * paying tenants, and nothing until the balance has actually arrived.
 */
export const DemoLookupBanner: React.FC = () => {
  const { isDemo, remaining, exhausted } = useDemoLookupAllowance();

  if (!isDemo || remaining === null) return null;

  return (
    <Alert
      type={exhausted ? 'warning' : 'info'}
      showIcon
      style={{ marginBottom: 16 }}
      title={
        exhausted
          ? 'No vehicle lookups left on your trial account'
          : `${remaining} vehicle lookups left on your trial account`
      }
      description={
        exhausted
          ? 'Get in touch with us to unlock unlimited lookups. Everything you have entered stays exactly as it is.'
          : undefined
      }
    />
  );
};
